import { useState } from "react";
import "./App.css";
import "./styles/brand-sections.css";
import "./components/landing/LandingSections.css";
import NavBar from "./components/layout/NavBar";
import DocumentDirection from "./components/common/DocumentDirection";
import ScrollToTopOnNavigate from "./components/common/ScrollToTopOnNavigate";
import SeoManager from "./components/seo/SeoManager";
import { ProductSeoProvider } from "./context/ProductSeoContext";

function App() {
  const [togol2, setTogol2] = useState(false);

  return (
    <ProductSeoProvider>
      <ScrollToTopOnNavigate />
      <div id="main" className="relative overflow-x-clip font">
        <SeoManager />
        <DocumentDirection />
        <NavBar togol2={togol2} setTogol2={setTogol2} />
      </div>
    </ProductSeoProvider>
  );
}

export default App;
